import type { HeaderService as HeaderServiceImpl } from '@patsnap-utils/biz';

export const HeaderService = Symbol.for('HeaderService');

export interface HeaderService extends HeaderServiceImpl {}
